const isValidIcid = (queryParam, request) => {
    const queryParamRegex = '^(?!  )[A-Za-z0-9-_:]+$';
    if (RegExp(queryParamRegex).test(queryParam)) {
        return true;
    }
    if (request !== null) {
        request.log('info', {
            category: 'icid',
            event: 'Invalid icid',
            queryParam
        });
    }
    return false;
};

export const collapseQueryParams = (queryParams = {}, baseUrl = '', request) => {
    if (Object.keys(queryParams).length === 0) {
        return '';
    }

    const keys = Object.keys(queryParams);
    // eslint-disable-next-line no-mixed-operators
    const filteredKeys = keys.filter(x => x !== 'icid' || x === 'icid' && isValidIcid(queryParams[x], request));
    const kvPairs = filteredKeys.map(key => `${key}=${encodeURIComponent(queryParams[key])}`);
    if (kvPairs.length === 0) return '';
    const firstDelimiter = baseUrl.indexOf('?') === -1 ? '?' : '&';
    return `${firstDelimiter}${kvPairs.join('&')}`;
};

export const canonicalizeUuid = (uuid) => {
    const uLength = uuid.length;
    let canonicalForm = uuid; // assume it is in canonical form
    if (uLength !== 36 && uLength !== 32) {
        canonicalForm = '-1';
    }
    if (uLength === 32) {
        const re = /(.{8})(.{4})(.{4})(.{4})(.{12})/;
        canonicalForm = uuid.replace(re, '$1-$2-$3-$4-$5');
    }

    return canonicalForm;
};

export const isEmpty = str => !str || str === '';

export const isNotEmpty = str => !isEmpty(str);

export default {
    collapseQueryParams,
    canonicalizeUuid
};
